<template>
	<div class="app-menu">
		<appLogo></appLogo>
		<Menu accordion v-if="currentAccountSets" :datas="menus" :inlineCollapsed="sliderCollapsed" @select="trigger" ref='menu' :className="`h-menu-${theme}`"></Menu>
		<div class="app-menu-mask" @click="hideMenu"></div>
	</div>
</template>
<script>

	import menuConfig from '../../js/config/menu-config';
	import {mapState} from 'vuex';
	import appLogo from './app-logo';

	// menu_key 到菜单项 key 的映射
	const MENU_KEY_MAP = {
		vouchers:     ['vouchers', 'VoucherForm', 'Voucher'],
		AccountBooks: ['AccountBooks', 'DetailedAccounts', 'GeneralLedger', 'SubjectBalance', 'SubjectSummary', 'AuxiliaryAccountingDetail', 'AuxiliaryAccountingBalance'],
		ReportList:   ['ReportList', 'ReportView', 'ReportTemplate', 'TemplateForm'],
		CheckList:    ['CheckList', 'UnCheckOut', 'CarryForward', 'Check'],
		FixedAssets:  ['FixedAssets', 'FixedAsset', 'DepreciationDetail', 'AssetCategory'],
		Cashier:      ['Cashier'],
		Invoice:      ['Invoice', 'InvoiceBusinessType'],
		Salary:       ['Salary'],
		Inventory:    ['Inventory'],
		Setting:      ['Setting', 'Account', 'Subject', 'Initial', 'Currency', 'VoucherWord', 'AccountingCategory', 'PermissionSetting', 'DataMigration'],
	};

	export default {
		name: "AppMenu",
		props: {
			theme: String
		},
		data() {
			return {
				menus: []
			};
		},
		watch: {
			$route() {
				this.menuSelect();
			},
			allowedMenus() {
				this.buildMenus();
			}
		},
		mounted() {
			this.buildMenus();
			this.menuSelect();
		},
		computed: {
			...mapState(['User', 'sliderCollapsed', 'currentAccountSets', 'allowedMenus'])
		},
		methods: {
			buildMenus() {
				console.log('buildMenus - User.role:', this.User.role, 'allowedMenus:', this.allowedMenus);
				const base = menuConfig[this.User.role] || [];
				console.log('buildMenus - base menus:', base.map(m => m.key));
				if (!this.allowedMenus) {
					// 未配置权限，全部显示
					console.log('buildMenus - 无权限配置，显示全部菜单');
					this.menus = base;
					return;
				}
				// 收集所有允许的菜单 key
				const allowed = new Set(['Home']);
				this.allowedMenus.forEach(mk => {
					console.log('buildMenus - 处理权限:', mk, '映射:', MENU_KEY_MAP[mk]);
					(MENU_KEY_MAP[mk] || []).forEach(k => allowed.add(k));
				});
				console.log('buildMenus - 允许的菜单keys:', [...allowed]);
				// 过滤菜单树
				this.menus = base.reduce((acc, item) => {
					if (!allowed.has(item.key)) {
						console.log('buildMenus - 过滤掉菜单:', item.key);
						return acc;
					}
					if (item.children) {
						const children = item.children.filter(c => allowed.has(c.key));
						acc.push({ ...item, children });
					} else {
						acc.push(item);
					}
					return acc;
				}, []);
				console.log('buildMenus - 最终菜单:', this.menus.map(m => m.key));
			},
			menuSelect() {
				if (this.$route.name && this.currentAccountSets) {
					this.$refs.menu.select(this.$route.name);
				}
			},
			trigger(data) {
				if (data.reportId) {
					this.$router.push({name: 'ReportView', params: {reportId: data.reportId}});
				} else {
					this.$router.push({name: data.key});
				}
			},
			hideMenu() {
				this.$store.commit('updateSliderCollapse', true);
			}
		},
		components: {
			appLogo
		}
	};
</script>
<style lang="less">

	.app-menu {
		.h-menu {
			font-size: 14px;

			.h-menu-li-selected {
				.h-menu-show:after {
					width: 4px;
				}
			}

			> li > .h-menu-show {
				font-size: 15px;

				.h-menu-show-icon {
					font-size: 20px;
				}

				.h-menu-show-desc {
					transition: opacity 0.1s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
				}
			}
		}

		.h-menu.h-menu-size-collapse > .h-menu-li > .h-menu-show {
			padding-left: 24px;

			.h-menu-show-icon {
				font-size: 20px;
			}
		}

		.h-menu.h-menu-white {
			color: rgb(49, 58, 70);
		}

	}

</style>
